<template>
    <div class="main bg-grey row">
        <div class="left-block">
            <div class="col left-block-container">
                <img
            id="olecio-logo"
            class="mr-2 mt-05 top-row-logo"
            src="https://oleciocdn.fra1.cdn.digitaloceanspaces.com/prod/cvtheque/CONSTRUCTYS_LOGO_TRANSPARENT_BLANC_BD.png"
            style="margin-top: 0.82rem"
          />
            <p id="preTitle" class="txt-white fontGrot">Avec ou sans CV</p>
            <h1 id="landingPageMainTitle" class="txt-white fontGrot">Trouvez un emploi dans le BTP</h1>
            <p class="txt-content txt-white fontGrot">+ de 1 500 entreprises recrutent en Ile-de-France. Rejoignez sans attendre un secteur porteur !</p>
            <div class="topBlockButtonContainer">
                <button class="txt-white fontGrot" @click="redirectToDemo">Je postule</button>
            </div>
            </div>
        </div>
        <div class="right-block">
        <div class="vidBlock">
          <video
          width="100%"
          height="100%"
          controls
          autoplay
          muted
          loop
          style="border-radius: 2rem;"
        >
          <source
            src="https://oleciocdn.fra1.cdn.digitaloceanspaces.com/prod/cvtheque/video-btp.mp4"
            type="video/mp4"
          />
          Votre navigateur ne supporte pas la balise vidéo.
        </video>
        </div>
    </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "PageBlock1",
    methods: {
      redirectToDemo() {
        //window.location.href = "https://demo.jobnavigator.fr/web/index.php/candidature/index#apply";
        // window.location.href = "https://jobnavigator.fr/web/index.php/candidature/index#apply";
        const utmSource = "olecio_job";
        window.location.href = `https://jobnavigator.fr/web/index.php/candidature/index#apply?utm_source=${encodeURIComponent(utmSource)}`;
        //window.location.href = "https://cvtheque-demo-7ykz3.ondigitalocean.app/web/index.php/candidature/index";
      }
    }
  };
  </script>
  
  <style src="../pages/landing-page.scss" lang="scss"></style>
  <style scoped>
.left-block,
.right-block {
  flex-basis: 50%;
}
.left-block {
    padding-left: 1rem;
    padding-top: 1rem;
    padding-right: 0rem;
    padding-bottom: 0rem;
}
.right-block {
    padding: 3rem;
}
/* .left-block{
    padding-right: 4rem;
} */
/* .left-block-container {
    padding-right: 2.5rem;
} */
.vidBlock {
    height: auto;
    border-radius: 2rem;
    /* padding-top: 8rem;
    padding-bottom: 8rem; */
    background-color: white;
}
  .left-block-container {
    padding-left: 3rem;
    padding-right: 1rem;
    align-items: flex-start;
  }
  #olecio-logo{
    padding-left: 0rem;
  }
  .left-block .txt-content {
    max-width: 30rem;
    text-align: start;
    padding-left: 0rem;
    padding-right: 4rem;
  }
  #preTitle,
  .topBlockButtonContainer {
    padding-left: 0rem;
  }
  .topBlockButtonContainer button {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  #preTitle {
    text-align: start;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    font-weight: 500;
    font-size: 1.875rem;
    line-height: 2.25rem;
}
#landingPageMainTitle {
    text-align: start;
    padding-right: 7rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    font-size: 3rem;
    line-height: 3.25rem;
}
  #olecio-logo {
    max-width: 8rem;
    margin-bottom: 1rem;
  }
  button {
    margin-top: 1rem;
    margin-bottom: 2rem;
    padding: 15px 40px;
    background-color: #e54021;
    color: white;
    border: none;
    cursor: pointer;
  }
  @media screen and (max-width: 460px) {
    .left-block{
      flex-basis: 100%;
      padding-left: 0rem;
    }
    .left-block-container{
      align-items: center;
      padding-left: 2rem;
      padding-right: 2rem;
    }
    #preTitle{
      font-size: 1.25rem;
      line-height: 1.75rem;
    }
    #landingPageMainTitle{
      font-size: 2.25rem;
      line-height: 2.5rem;
    }
    .left-block .txt-content,
    #landingPageMainTitle{
      text-align: center;
      padding-left: 1rem;
      padding-right: 1rem;
    }
    .right-block,
  .block3-row {
    display: none;
  }
  
  .landingPageTitle {
    font-size: 2rem;
  }

  .ButtonContainer {
    margin-top: 1rem;
  }

  button {
    font-size: 1.25rem;
    padding: 12px 30px;
  }
}
@media screen and (min-width: 1351px) {
  .left-block-container{
    padding-left: 5rem;
    padding-top: 2rem;
  }
}
@media screen and (min-width: 1501px) {
  .vidBlock{
    max-width: 85%;
  }
}
@media screen and (min-width: 1551px) {
  #olecio-logo {
    max-width: 12rem;
    margin-bottom: 2rem;
  }
  .left-block-container{
    padding-top: 1rem;
    padding-left: 8rem;
    padding-right: 0rem;
  }
  .vidBlock{
    max-width: 75%;
  }
}
@media screen and (min-width: 1650px){
  #landingPageMainTitle{
    font-size: 3.25rem;
    line-height: 3.5rem;
  }
}
  </style>